<script setup lang="ts">

import { reactive } from "vue";
import { currency, formatDate } from "@library/Utilities";
import type { IMyGarageViewModel } from "../../..";

const model = defineModel<IMyGarageViewModel>( { required: true } );  
const serviceLog = reactive( model.value.serviceLog );
const hasItems = serviceLog.length > 0;

</script>

<template>

    <div class="flex flex-col w-full h-full items-start pb-32 text-base">

        <!-- THERE ARE PREVIOUS SERVICE ITEMS TO DISPLAY -->
        <div v-if="hasItems" 
             class="bg-gray-100/20 dark:bg-transparent w-full">

            <div class="w-full h-max table overflow-hidden">

                <div class="uppercase pt-5 pb-2 3xl:pb-4 px-4 text-sm lg:text-base 3xl:text-lg grid grid-cols-5 bg-gray-850">
                    <span class="col-span-4">Completed Services</span>
                    <span class="col-span-1 text-right">Cost</span>
                </div>

                <div v-for="item in serviceLog"
                     class="bg-white dark:bg-gray-800 py-4 px-4 mb-0.5 last:mb-0
                            grid grid-cols-5 items-center">
                    <div class="col-span-4 tracking-wider">
                        <div class="text-base 3xl:text-lg">{{ item.title }}</div>
                        <div class="text-sm 3xl:text-base opacity-60">
                            {{ formatDate( item.utcDateCreated, 'dddd, Do MMM YYYY' ) }}
                        </div>
                    </div>
                    <div class="col-span-1 text-right">
                        <div class="text-base 3xl:text-lg">{{ currency( item.purchaseAmount ) }}</div>
                        <div v-if="item.cashbackAmount != undefined" 
                             class="text-sm 3xl:text-base text-secondary-500">
                            {{ currency( item.cashbackAmount ) }}
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <!-- THERE ARE NO PREVIOUS SERVICE ITEMS -->
        <div v-else class="text-base 3xl:text-lg px-4 lg:px-6 mt-4 3xl:mt-6 opacity-60">
            There are no completed services to display
        </div>

    </div>
                    
</template>